import React from 'react';
import cls from 'classnames';
import { ratioMap, Size } from '../generated/base/ratios';
import { ColorClassnames } from '../../../tailwind/src/theme';

export interface IconContainerProps {
	className?: string;
	children: React.ReactNode;
	size?: Size;
	color?: ColorClassnames;
}

// interface for each individual icon
export type IconProps = Omit<IconContainerProps, 'children'>;

function IconContainer(props: IconContainerProps) {
	const { className, color, size = 'XS', ...rest } = props;
	const ratioStyles = ratioMap['square'][size];
	return (
		<div
			aria-hidden="true"
			className={cls('inline-block', className, color)}
			style={ratioStyles}
			{...rest}
		/>
	);
}

export default IconContainer;
